export default "__VITE_ASSET__B2JM6IvW__"